<template>
    <div v-if="isMobile" class="lite-product-fabs d-md-none fixed-bottom d-flex p-1 bg-slate-200 gap-1"
        :style="liteProductFabStyles">
        <a v-if="!loginUserId" href="/login" title="登入" class="btn btn-lg btn-light btn-footer-icon"
            style="color: #eb1c74 !important;" role="button" aria-disabled="true">
            <i class="navbar-tool-icon czi-user"></i>
        </a>
        <button v-if="!hiddenContact && fbmsnBaseUrl" title="聯絡客服" type="button" class="btn btn-lg btn-light btn-footer-icon"
            @click="handleContactCustomerService" role="button" aria-disabled="true">
            <i class="navbar-tool-icon czi-message"></i>
        </button>
        <template v-if="!hiddenCart && store.getters['lite/cartCount']">
            <button v-if="isBlockCartVisible" type="button"
                class="btn btn-lg btn-primary btn-block btn-footer-icon mt-0 text-2xl fab-checkout" role="button"
                aria-disabled="true" @click="handleOpenCheckoutDialog">
                <i class="fa fa-hand-pointer-o mr-2" aria-hidden="true"></i>
                下一步
            </button>
            <button v-else type="button" class="btn btn-lg btn-primary btn-block btn-footer-icon mt-0 text-2xl fab-viewcart"
                role="button" aria-disabled="true" @click="handleViewCart">
                <i class="fa fa-hand-pointer-o mr-2" aria-hidden="true"></i>
                {{ aliasTranslations?.checkout || t("carts.checkout") }}
            </button>
        </template>
        <template v-else>
            <button v-if="!hiddenCart" type="button" class="btn btn-lg btn-primary btn-block btn-footer-icon mt-0 text-2xl" role="button"
                aria-disabled="true" @click="handleBuyNow">
                <i class="fa fa-hand-pointer-o mr-2" aria-hidden="true"></i>
                {{ aliasTranslations?.buy_now || t("carts.buyNow") }}
            </button>
        </template>
    </div>
    <div v-else class="lite-product-fabs" :style="liteProductFabStyles">
        <el-avatar v-show="showScrollTopButton" class="fab-scrolltop" :size="fabSize" @click="handleScrollToTop">
            <i class="btn-scroll-top-icon czi-arrow-up"> </i>
        </el-avatar>
        <el-avatar v-if="!hiddenContact && fbmsnBaseUrl" :size="fabSize" class="fab-contact-customer-service"
            @click="handleContactCustomerService">
            聯絡
            <br />
            客服
        </el-avatar>

        <div v-if="!hiddenCart">
            <el-avatar v-if="store.getters['lite/cartCount']" :size="fabSize" class="fab-viewcart" @click="handleViewCart">
                <span v-if="!!aliasTranslations?.checkout">{{ aliasTranslations?.checkout }}</span>
                <span v-else>立即<br />結帳</span>
            </el-avatar>
            <el-avatar v-else :size="fabSize" class="fab-buynow" @click="handleBuyNow">
                <span v-if="!!aliasTranslations?.buy_now">{{ aliasTranslations?.buy_now }}</span>
                <span v-else>立即<br />購買</span>
            </el-avatar>
        </div>
    </div>
</template>
  
<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useI18n } from "vue-i18n"
import { useStore } from 'vuex'
import { breakpoint, lookupAliasTranslations } from "../../utils"

const props = defineProps({})
const { t, locale } = useI18n()

const store = useStore()

const isMobile = computed(() => breakpoint.value.xs || breakpoint.value.sm)
const storeData = computed(() => store.getters["lite/storeData"])
const hiddenPrice = computed(() => !!storeData.value?.settings?.hidden_price)
const hiddenCart = computed(() => !!storeData.value?.settings?.hidden_cart)
const hiddenContact = computed(() => !!storeData.value?.settings?.hidden_contact)
const aliasTranslations = computed(() => lookupAliasTranslations(storeData.value?.alias_translations, locale.value))

const liteProductFabStyles = computed(() => {
    if (isMobile.value) {
        return {
            left: 0,
            right: 0,
            bottom: 0,
            height: '74px',
            zIndex: 2001,
        }
    }
    return {
        bottom: '20px',
        right: '20px',
        zIndex: 2001,
    }
})
const fabSize = computed(() => isMobile.value ? 50 : 75);
const loginUserId = computed(() => store.getters['lite/userData']?.id);
const fbmsnBaseUrl = computed(() => storeData.value?.fbmsn_base_url);

const showScrollTopButton = ref(false);
const isBlockCartVisible = ref(false);

const checkScroll = () => {
    showScrollTopButton.value = window.scrollY > 200;
}

const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.target.id === 'block-carts') {
            isBlockCartVisible.value = entry.isIntersecting;
        }
    });
}, {
    root: null,
    threshold: 0.1,
});

onMounted(() => {
    window.addEventListener('scroll', checkScroll);
    const blockCartElement = document.getElementById('block-carts');
    if (blockCartElement) {
        observer.observe(blockCartElement);
    }
})

onUnmounted(() => {
    window.removeEventListener('scroll', checkScroll);
    const blockCartElement = document.getElementById('block-carts');
    if (blockCartElement) {
        observer.unobserve(blockCartElement);
    }
})

const handleScrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
}

const handleBuyNow = () => {
    const scrollElem = document.getElementById("block-products");
    scrollElem &&
        scrollElem.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
        });
}

const handleViewCart = () => {
    const scrollElem = document.getElementById("block-carts");
    scrollElem &&
        scrollElem.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
        });
}

const handleOpenCheckoutDialog = () => {
    store.dispatch('lite/openCheckoutDialog');
}

const handleContactCustomerService = () => {
    window.contactToFBMSN();
}

</script>

<style lang="scss" scoped>
.lite-product-fabs {
    position: fixed;

    .el-avatar {
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: background-color 0.3s;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
        margin-bottom: 10px;
        line-height: 18px;

        &:hover {
            box-shadow: 0 6px 12px rgba(0, 0, 0, 0.4);
        }

        &:active {
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
        }
    }

    .fab-contact-customer-service {
        background-color: #A020F0;

        &:hover {
            background-color: darken(#A020F0, 10%);
        }

        &:active {
            background-color: darken(#A020F0, 20%);
        }
    }

    .fab-viewcart {
        background-color: darken(#ff0000, 10%);

        &:active {
            background-color: darken(#ff0000, 20%);
        }
    }

    .fab-buynow {
        background-color: var(--primary_color);

        // &:hover {
        //     background-color: var(--primary_color_dark);
        // }

        &:active {
            background-color: darken(#888, 20%);
        }
    }

    .fab-scrolltop {
        background-color: #888;

        &:hover {
            background-color: darken(#888, 10%);
        }

        &:active {
            background-color: darken(#888, 20%);
        }
    }
}
</style>
